/* Happy Tooth quiz funnel. Content comes from the ht-quiz section (theme editor).
   Locked logic: routing in plan() reads answer KEYS (left column of each answer line). */
(function () {
  var root = document.querySelector('[data-htq]');
  if (!root) return;
  var D = JSON.parse(root.querySelector('script[data-htq-json]').textContent);
  var lines = function (s) { return (s || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean).map(function (l) { return l.split('|').map(function (x) { return x.trim(); }); }); };
  var screens = D.screens.filter(Boolean);
  screens.forEach(function (s) { if (s.answers) s.o = lines(s.answers); if (s.rows) s.r = lines(s.rows); if (s.steps) s.st = lines(s.steps).map(function (x) { return x[0]; }); });
  var S = screens.concat([{ type: 'load' }, { type: 'res' }]);
  var KEY = 'htq-' + D.sid;
  var st = null;
  try { st = JSON.parse(sessionStorage.getItem(KEY)); } catch (e) {}
  if (!st || st.n !== S.length) st = { i: 0, a: {}, sub: true, skipped: false, n: S.length };
  var save = function () { try { sessionStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} };
  var $ = function (s) { return root.querySelector(s); };
  var main = $('[data-htq-main]'), more = $('[data-htq-more]'), sticky = $('[data-htq-sticky]');
  var timers = [];
  var COLORS = ['var(--htq-cool)', 'var(--htq-peach)', 'var(--htq-sage)', 'var(--htq-mustard)', '#fff', 'var(--htq-cream)'];
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  var ans = function (id) { return st.a[id] || []; };
  var path = function () { return ans('who').indexOf('me') > -1 ? 'adult' : 'kids'; };
  var on = function (s) { return !s.path || s.path === 'both' || s.path === path(); };
  var adultRes = function () { return path() === 'adult' && !st.skipped; };
  function nxt(i, d) { var j = i + d; while (S[j] && (!on(S[j]) || (d < 0 && S[j].type === 'load'))) j += d; return j; }
  function go(i) { timers.forEach(clearTimeout); timers = []; st.i = Math.max(0, Math.min(S.length - 1, i)); save(); render(); window.scrollTo(0, 0); }
  function next() { go(nxt(st.i, 1)); }
  function firstOn() { for (var k = 0; k < S.length; k++) if (on(S[k])) return k; return 0; }

  function money(c) {
    var n = (c || 0) / 100, f = D.moneyFormat || '${{amount}}';
    var two = n.toFixed(2), parts = two.split('.');
    var withC = function (sep, dec) { return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (dec ? dec + parts[1] : ''); };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      return k === 'amount_no_decimals' ? withC(',', '').split('.')[0] : k === 'amount_with_comma_separator' ? withC('.', ',') : k === 'amount_no_decimals_with_comma_separator' ? withC('.', '') : withC(',', '.');
    });
  }
  var tpl = function (s, o) { return String(s || '').replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); };
  var listJoin = function (a) { return a.length > 1 ? a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1] : (a[0] || ''); };

  function render() {
    var s = S[st.i];
    $('[data-htq-back]').style.visibility = (st.i === firstOn() || s.type === 'load') ? 'hidden' : 'visible';
    $('[data-htq-skip]').style.display = (s.type === 'res' || s.type === 'load') ? 'none' : 'flex';
    $('[data-htq-bar]').style.display = s.type === 'res' ? 'none' : 'block';
    $('[data-htq-sub]').innerHTML = s.type === 'res' ? (adultRes() ? D.t.resAdult : D.t.resKids) : (path() === 'adult' ? D.t.titleAdult : D.t.titleKids);
    var L = S.filter(on), pct = (s.type === 'load' || s.type === 'res') ? 100 : Math.round(L.indexOf(s) / (L.length - 2) * 100) + 4;
    var fill = $('[data-htq-fill]'); fill.style.width = pct + '%'; fill.classList.toggle('is-full', pct >= 100);
    main.innerHTML = ({ question: vQ, info: vInfo, ha: vHa, commit: vCommit, load: vLoad, res: vRes })[s.type](s);
    var res = s.type === 'res';
    more.hidden = !res; sticky.hidden = !res;
    if (res) {
      more.querySelectorAll('[data-htq-adult]').forEach(function (el) { el.hidden = !adultRes(); });
      more.querySelectorAll('[data-htq-kids]').forEach(function (el) { el.hidden = adultRes(); });
    }
    if (s.type === 'load') runLoader();
  }

  function step(s) {
    var q = S.filter(function (x) { return on(x) && x.type === 'question'; });
    return '<p class="q-step">' + tpl(D.t.qLabel, { n: q.indexOf(s) + 1, total: q.length }) + '</p>';
  }
  var trust = function () { return D.t.trustRating || D.t.trustText ? '<div class="trust"><span class="stars" aria-hidden="true">★★★★★</span><span>' + D.t.trustRating + '</span><span class="trust__dr">' + D.t.trustText + '</span></div>' : ''; };
  var foot = function (lbl, dis) { return '<div class="foot"><button type="button" class="btn" data-next="1"' + (dis ? ' disabled' : '') + '>' + lbl + '</button></div>'; };

  function vQ(s) {
    var v = ans(s.qid), opts;
    if (s.style === 'number') {
      opts = '<div class="opts opts--2">' + s.o.map(function (o) { return '<button type="button" class="opt opt--num' + (v.indexOf(o[0]) > -1 ? ' is-on' : '') + '" data-a="' + esc(o[0]) + '"><span class="opt__n">' + esc(o[0]) + '</span><span class="opt__lbl">' + (o[1] || '') + '</span></button>'; }).join('') + '</div>';
    } else {
      opts = '<div class="opts">' + s.o.map(function (o, k) {
        var ico = s.style === 'mono' ? '<span class="opt__mono" style="background:' + COLORS[k % COLORS.length] + '">' + (o[2] || '') + '</span>' : '<span class="opt__ico">' + (o[2] || '') + '</span>';
        return '<button type="button" class="opt' + (s.multi ? '' : ' opt--radio') + (v.indexOf(o[0]) > -1 ? ' is-on' : '') + '" data-a="' + esc(o[0]) + '"' + (s.multi ? ' aria-pressed="' + (v.indexOf(o[0]) > -1) + '"' : '') + '>' + ico + '<span class="opt__lbl">' + (o[1] || o[0]) + '</span><span class="opt__chk"></span></button>';
      }).join('') + '</div>';
    }
    var first = st.i === firstOn();
    return '<div class="scr"' + (s.multi ? ' style="flex:1"' : '') + '>' + step(s) + '<h1 class="q-h">' + s.h + '</h1>' + (s.hint ? '<p class="q-hint">' + s.hint + '</p>' : '') + opts + (first ? trust() : '') + (s.multi ? foot(D.t.next, !v.length) : '') + '</div>';
  }
  function vInfo(s) {
    return '<div class="scr" style="flex:1">' + (s.eyebrow ? '<p class="q-step">' + s.eyebrow + '</p>' : '') + '<h1 class="q-h">' + s.h + '</h1>' + (s.sub ? '<p class="q-hint" style="margin-top:-8px">' + s.sub + '</p>' : '') +
      '<div class="edu">' + (s.r || []).map(function (r, k) { return '<div class="edu__row"><span class="edu__ico" style="background:' + COLORS[(k + 1) % 4] + '">' + (r[0] || '') + '</span><div><h3>' + (r[1] || '') + '</h3>' + (r[2] ? '<p>' + r[2] + '</p>' : '') + '</div></div>'; }).join('') + '</div>' +
      (s.closing ? '<p class="better">' + s.closing + '</p>' : '') + foot(s.btn || D.t.next) + '</div>';
  }
  function vHa(s) {
    return '<div class="scr" style="flex:1">' + (s.eyebrow ? '<p class="q-step">' + s.eyebrow + '</p>' : '') + '<h1 class="q-h">' + s.h + '</h1><div class="ha">' +
      (s.img ? '<div class="ha__img"><img src="' + s.img + '" alt="" loading="lazy"></div>' : '') +
      (s.title ? '<h2 class="ha__t">' + s.title + '</h2>' : '') + (s.body ? '<p class="ha__big">' + s.body + '</p>' : '') +
      (s.st && s.st.length ? '<div class="ha__steps">' + s.st.map(function (t, k) { return '<div class="ha__step"><b>' + (k + 1) + '</b><span>' + t + '</span></div>'; }).join('') + '</div>' : '') + '</div>' +
      (s.quote || s.drImg ? '<div class="doc"><div class="doc__ph">' + (s.drImg ? '<img src="' + s.drImg + '" alt="' + esc(s.drName) + '" loading="lazy">' : '') + '</div><div><p class="doc__q">' + s.quote + '</p><p class="doc__n">' + s.drName + '</p></div></div>' : '') +
      foot(s.btn || D.t.next) + '</div>';
  }
  function vCommit(s) {
    return '<div class="scr" style="flex:1">' + (s.eyebrow ? '<p class="q-step">' + s.eyebrow + '</p>' : '') + '<h1 class="q-h">' + s.h + '</h1>' + (s.sub ? '<p class="q-hint" style="margin-top:-8px">' + s.sub + '</p>' : '') +
      '<div class="commit">' + (s.r || []).map(function (r) { return '<div class="commit__row"><b>' + (r[0] || '') + '</b><span>' + (r[1] || '') + '</span></div>'; }).join('') + '</div>' +
      '<div class="foot" style="display:flex;flex-direction:column;gap:14px"><button type="button" class="btn" data-next="1">' + s.yes + '</button>' + (s.no ? '<p class="nothanks"><a href="#" data-skip="1">' + s.no + '</a></p>' : '') + '</div></div>';
  }
  function vLoad() {
    var a = path() === 'adult';
    return '<div class="scr load"><div class="load__ring" aria-hidden="true"></div><h1 class="q-h" style="text-align:center">' + (a ? D.t.loadAdult : D.t.loadKids) + '</h1><div class="load__list">' +
      lines(a ? D.t.loadStepsAdult : D.t.loadStepsKids).map(function (r) { return '<div class="load__item"><i></i>' + r[0] + '</div>'; }).join('') + '</div></div>';
  }
  function runLoader() {
    main.querySelectorAll('.load__item').forEach(function (el, k) { timers.push(setTimeout(function () { el.classList.add('is-done'); }, 700 + k * 800)); });
    timers.push(setTimeout(function () { st.skipped = false; go(S.length - 1); }, 3200));
  }

  /* ---------- LOCKED ROUTING ---------- */
  function q(id) { for (var k = 0; k < S.length; k++) if (S[k].qid === id) return S[k]; return null; }
  function phrases(id) {
    var s = q(id), v = ans(id); if (!s) return [];
    return s.o.filter(function (o) { return v.indexOf(o[0]) > -1; }).map(function (o) { return o[3] || String(o[1] || o[0]).toLowerCase(); });
  }
  function plan() {
    var R = D.route, key, head, flav = '';
    if (adultRes()) {
      var g = ans('agoal'), fl = q('aflavor');
      key = g.indexOf('whiter') > -1 ? R.adultWhiter : R.adultDefault;
      if (fl) flav = fl.o.filter(function (o) { return ans('aflavor').indexOf(o[0]) > -1; }).map(function (o) { return o[1]; }).join(', ');
      var gl = phrases('agoal');
      head = gl.length ? tpl(D.t.headAdult, { goals: listJoin(gl) }) : D.t.headAdultNone;
    } else if (st.skipped || !ans('ages').length) {
      key = R.skip; head = D.t.headSkip;
    } else {
      var kids = ans('kids')[0] || '1', ages = ans('ages'), mat = ans('matters');
      key = kids !== '1' ? R.kidsMulti : (ages.indexOf('teen') > -1 || mat.indexOf('enamel') > -1) ? R.kidsTeen : R.kidsDefault;
      var ks = q('kids'), ko = ks && ks.o.filter(function (o) { return o[0] === kids; })[0];
      var al = phrases('ages'), num = al.some(function (x) { return /^\d/.test(x); });
      head = tpl(D.t.headKids, { kids: kids + ' ' + (ko && ko[1] ? ko[1] : (kids === '1' ? 'kid' : 'kids')), ages: (num ? 'ages ' : '') + listJoin(al) });
      flav = D.t.kidsFlavor;
    }
    var b = D.bundles[key] || D.bundles.A;
    var items = lines(b.items).map(function (r) { return { q: r[0], name: r[1] || '', img: r[2] || '', desc: (r[2] === 'toothpaste' && flav) ? flav : (r[3] || '') }; });
    return { key: key, b: b, items: items, head: head };
  }

  function vRes() {
    var p = plan(), b = p.b, canSub = !!b.plan, sub = canSub && st.sub;
    var total = sub ? b.plan.price : b.price, was = b.was > total ? b.was : 0;
    var pctOff = canSub && b.price ? Math.round((1 - b.plan.price / b.price) * 100) : 0;
    var noProd = !b.variant;
    sticky.innerHTML = '<div class="sticky__p"><b>' + money(total) + '</b>' + (was ? '<s>' + money(was) + '</s>' : '') + '</div><button type="button" class="btn" data-add="1"' + (noProd ? ' disabled' : '') + '>' + D.t.cta + ' &rarr;</button>';
    return '<div class="scr res"><div class="res__hi">' + (D.t.badge ? '<span class="badge"><span class="dot"></span>' + D.t.badge + '</span>' : '') + '<h1 class="q-h">' + p.head + '</h1>' + (D.t.offerEnd ? '<p class="ends">' + D.t.offerEnd + '</p>' : '') + '</div>' +
      '<div class="bund"><div class="bund__top"><div><h2 class="bund__name">' + b.name + '</h2>' + (b.tag ? '<p class="bund__tag">' + b.tag + '</p>' : '') + '</div>' + (D.t.bundleBadge ? '<span class="bund__off">' + D.t.bundleBadge + '</span>' : '') + '</div>' +
      '<div class="bund__items">' + p.items.map(function (x, k) {
        var im = D.imgs[x.img];
        return '<div class="item"><div class="item__img" style="background:' + COLORS[(k + 2) % 4] + '">' + (im ? '<img src="' + im + '" alt="" loading="lazy">' : esc(x.name.replace(/[\[\]]/g, '').charAt(0))) + '</div><div><h4>' + x.name + '</h4>' + (x.desc ? '<p>' + x.desc + '</p>' : '') + '</div><div class="item__pr">&times;' + esc(x.q) + '</div></div>';
      }).join('') + '</div>' +
      '<div class="bund__buy">' + (noProd ? '<p class="htq-warn">Pick a product for bundle ' + p.key + ' in the theme editor.</p>' : '') +
      (canSub ? '<div class="tog" role="radiogroup" aria-label="Purchase option">' +
        '<button type="button" class="tog__o' + (sub ? ' is-on' : '') + '" data-sub="1" role="radio" aria-checked="' + sub + '"><span class="tog__r"></span><span class="tog__t"><b>' + tpl(D.t.subLabel, { pct: pctOff }) + '</b><small>' + tpl(D.t.subNote, { plan: esc(b.plan.name) }) + '</small></span><span class="tog__p">' + money(b.plan.price) + '</span></button>' +
        '<button type="button" class="tog__o' + (sub ? '' : ' is-on') + '" data-sub="0" role="radio" aria-checked="' + !sub + '"><span class="tog__r"></span><span class="tog__t"><b>' + D.t.onceLabel + '</b><small>' + D.t.onceNote + '</small></span><span class="tog__p">' + money(b.price) + '</span></button></div>' : '') +
      '<div class="price"><span class="price__now">' + money(total) + '</span>' + (was ? '<span class="price__was">' + money(was) + '</span>' : '') + '</div>' +
      (D.t.gift && (sub || !D.t.giftSubOnly) ? '<div class="perk perk--gift">🎁 <span>' + D.t.gift + '</span></div>' : '') +
      (D.freeShip && total >= D.freeShip ? '<div class="perk perk--ship">📦 ' + D.t.freeShipText + '</div>' : '') +
      '<button type="button" class="btn" data-add="1"' + (noProd ? ' disabled' : '') + '>' + D.t.cta + '</button><p class="htq-err" data-htq-err hidden></p></div></div></div>';
  }

  function postAdd(item) {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); }); window.location.href = base + (D.afterAdd === 'checkout' ? 'checkout' : 'cart'); });
  }

  /* ---------- Flavor pop-up (snippets/ht-quiz-flavors) ---------- */
  var FM = document.getElementById('htqFlavor'), fmItem = null, fmBusy = false, fmLast = null;
  if (FM) {
    if (FM.parentElement !== document.body) document.body.appendChild(FM);
    var fmForm = FM.querySelector('form'), fmSum = FM.querySelector('.fbm-sum'), fmErr = FM.querySelector('.fbm-err'), fmGo = FM.querySelector('.fbm-go');
    var fmSet = function () { return fmItem && FM.querySelector('.htqf-set[data-variant="' + fmItem.id + '"]'); };
    var fmPicks = function () {
      var set = fmSet(); if (!set) return [];
      return [].map.call(set.querySelectorAll('fieldset'), function (fs) { var c = fs.querySelector('input:checked'); return { name: fs.getAttribute('data-name'), value: c ? c.value : '' }; });
    };
    var fmRender = function () { fmSum.innerHTML = 'Your bundle: <b>' + fmPicks().map(function (x) { return esc(x.value) || '&mdash;'; }).join(' + ') + '</b>'; };
    var fmClose = function () {
      if (fmBusy) return;
      FM.classList.remove('is-open'); FM.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('fbm-lock');
      if (fmLast && fmLast.focus) fmLast.focus();
    };
    FM.querySelector('.fbm-close').addEventListener('click', fmClose);
    FM.addEventListener('click', function (e) { if (e.target === FM) fmClose(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && FM.classList.contains('is-open')) fmClose(); });
    fmForm.addEventListener('change', fmRender);
    fmForm.addEventListener('submit', function (e) {
      e.preventDefault(); if (fmBusy || !fmItem) return;
      var p = fmPicks(), miss = p.filter(function (x) { return !x.value; });
      if (miss.length) { fmErr.textContent = 'Please choose a ' + miss[0].name.trim() + '.'; return; }
      p.forEach(function (x) { fmItem.properties[x.name] = x.value; });
      fmItem.properties._bundle_selection = p.map(function (x) { return x.value; }).join(' <> ');
      fmBusy = true; fmGo.disabled = true; fmErr.textContent = ''; var lbl = fmGo.innerHTML; fmGo.textContent = D.t.adding;
      postAdd(fmItem).catch(function (x) { fmBusy = false; fmGo.disabled = false; fmGo.innerHTML = lbl; fmErr.textContent = x.message; });
    });
  }
  function openFlavors(item, total) {
    fmItem = item; fmLast = document.activeElement;
    var set = fmSet(); if (!set) return false;
    FM.querySelectorAll('.htqf-set').forEach(function (x) { x.hidden = x !== set; });
    /* preselect: adult flavor answers first, then first in-stock option */
    var pref = [];
    if (adultRes() && ans('aflavor').length) { var fl = q('aflavor'); pref = fl.o.filter(function (o) { return ans('aflavor').indexOf(o[0]) > -1; }).map(function (o) { return String(o[1]).toLowerCase(); }); }
    var tpN = 0;
    set.querySelectorAll('fieldset').forEach(function (fs) {
      if (fs.querySelector('input:checked')) return;
      var ins = [].filter.call(fs.querySelectorAll('input'), function (i) { return !i.disabled; }); if (!ins.length) return;
      var pick = null;
      if (pref.length) {
        var order = fs.dataset.kind === 'tp' ? pref.slice(tpN % pref.length).concat(pref.slice(0, tpN % pref.length)) : pref;
        for (var k = 0; k < order.length && !pick; k++) pick = ins.filter(function (i) { var b = i.dataset.base; return b === order[k] || order[k].indexOf(b) > -1 || b.indexOf(order[k]) > -1; })[0] || null;
        if (fs.dataset.kind === 'tp') tpN++;
      }
      (pick || ins[0]).checked = true;
    });
    fmErr.textContent = ''; fmGo.disabled = false; fmGo.innerHTML = D.t.cta + ' &middot; ' + money(total);
    fmRender();
    FM.classList.add('is-open'); FM.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('fbm-lock');
    var first = set.querySelector('input:checked'); if (first) first.focus();
    return true;
  }

  function addToCart(btn) {
    var p = plan(), b = p.b; if (!b.variant) return;
    var item = { id: b.variant, quantity: 1, properties: {} };
    var sub = !!(b.plan && st.sub);
    if (sub) item.selling_plan = b.plan.id;
    item.properties._quiz_bundle = p.key;
    if (FM && openFlavors(item, sub ? b.plan.price : b.price)) return;
    if (adultRes() && ans('aflavor').length) {
      var fl = q('aflavor'); item.properties.Flavors = fl.o.filter(function (o) { return ans('aflavor').indexOf(o[0]) > -1; }).map(function (o) { return o[1]; }).join(', ');
    }
    root.querySelectorAll('[data-add]').forEach(function (x) { x.disabled = true; x.dataset.lbl = x.innerHTML; x.textContent = D.t.adding; });
    postAdd(item).catch(function (e) {
      root.querySelectorAll('[data-add]').forEach(function (x) { x.disabled = false; x.innerHTML = x.dataset.lbl; });
      var er = root.querySelector('[data-htq-err]'); if (er) { er.hidden = false; er.textContent = e.message; }
    });
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-a],[data-next],[data-sub],[data-add],[data-skip],[data-htq-back]'); if (!t) return;
    var s = S[st.i];
    if (t.hasAttribute('data-skip')) { e.preventDefault(); st.skipped = true; go(S.length - 1); return; }
    if (t.hasAttribute('data-htq-back')) { go(st.i === S.length - 1 && st.skipped ? firstOn() : nxt(st.i, -1)); return; }
    if (t.hasAttribute('data-add')) { addToCart(t); return; }
    if (t.dataset.a !== undefined) {
      var k = t.dataset.a;
      if (s.multi) {
        var v = ans(s.qid).slice(), i = v.indexOf(k); if (i < 0) v.push(k); else v.splice(i, 1);
        st.a[s.qid] = v; save(); t.classList.toggle('is-on', i < 0); t.setAttribute('aria-pressed', i < 0);
        var nb = main.querySelector('[data-next]'); if (nb) nb.disabled = !v.length;
      } else {
        st.a[s.qid] = [k]; if (s.qid === 'who') st.skipped = false; save();
        main.querySelectorAll('.opt').forEach(function (o) { o.classList.toggle('is-on', o === t); });
        setTimeout(next, 260);
      }
      return;
    }
    if (t.hasAttribute('data-next')) { next(); return; }
    if (t.dataset.sub !== undefined) { st.sub = t.dataset.sub === '1'; save(); var y = window.scrollY; render(); window.scrollTo(0, y); }
  });

  /* Theme editor: selecting a block jumps to its screen. */
  document.addEventListener('shopify:block:select', function (e) {
    var id = e.detail && e.detail.blockId, i = -1;
    for (var k = 0; k < S.length; k++) if (S[k].bid === id) i = k;
    if (i > -1) { if (S[i].path === 'adult') st.a.who = ['me']; else if (S[i].path === 'kids') st.a.who = ['kids']; st.skipped = false; go(i); }
    else if (more.contains(e.target)) go(S.length - 1);
  });

  render();
})();
